"use client";

import React from "react";
import { Plane, Users, Briefcase, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Flight Tracking",
  description: "Real-time monitoring of your flight status to ensure timely pickups, regardless of delays or early arrivals.",
  icon: Plane
}, {
  title: "Meet & Greet",
  description: "Professional chauffeurs waiting for you at arrivals with a personalized sign, ready to assist you immediately.",
  icon: Users
}, {
  title: "Luggage Assistance",
  description: "Complimentary, courteous help with your baggage from the terminal directly to your waiting luxury vehicle.",
  icon: Briefcase
}];
const benefits = [{
  title: "Unmatched Reliability",
  description: "We pride ourselves on absolute punctuality and dependable service for every single journey."
}, {
  title: "Premium Fleet",
  description: "Travel in ultimate comfort and style with our meticulously maintained, late-model luxury vehicles."
}];
export default function ServiceDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="service-details" className="bg-background py-20 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col gap-10">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <div key={i} data-index={i} className="flex items-start gap-6 group">
                  <div className="shrink-0 p-4 rounded-full bg-primary/5 group-hover:bg-primary/10 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-primary stroke-2" />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-foreground mb-2">
                      {feature.title}
                    </h3>
                    <p className="font-sans text-base text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground leading-tight mb-6">
                Why Choose Phoenix Enterprise
              </h2>
              <p className="font-sans text-base text-muted-foreground leading-relaxed">
                Experience the pinnacle of luxury transportation. Our commitment to excellence ensures that every ride is more than just a journey—it's a seamless, stress-free experience tailored to your exacting standards. From corporate travel to special events, we deliver uncompromising quality.
              </p>
            </div>

            <div className="flex flex-col gap-6 mt-2">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="border-l-4 border-secondary pl-6 py-1">
                  <h4 className="font-display text-lg font-bold text-foreground mb-1">
                    {benefit.title}
                  </h4>
                  <p className="font-sans text-sm text-muted-foreground">
                    {benefit.description}
                  </p>
                </div>)}
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="btn-primary">
                <Link to="/ReservationsPage">
                  Book Your Ride <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}